import { Box, useTheme } from '@mui/material';
import { Point } from 'highcharts';
import { get } from 'lodash';
import ExpandableBox from 'src/components/common/ExpandableBox';
import WorldMapChart from 'src/components/HighChart/WorldMapChart';
import { getDataLabelOptionBillOfLanding, WorldMapOptions } from 'src/components/HighChart/WorldMapChart/config';

const MapAddress = ({ tradeDataDetail }: { tradeDataDetail: IBillOfLadingDetail }) => {
  const theme = useTheme();
  const locationImport = {
    country_code: tradeDataDetail?.import_port?.country_code || tradeDataDetail?.import_country?.country_code,
    latitude: tradeDataDetail?.import_port?.latitude || tradeDataDetail?.import_country?.latitude,
    longitude: tradeDataDetail?.import_port?.longitude || tradeDataDetail?.import_country?.longitude,
    port_name: tradeDataDetail?.transaction?.import_port,
    address: tradeDataDetail?.import_port?.address,
  };

  const locationExport = {
    country_code: tradeDataDetail?.export_port?.country_code || tradeDataDetail?.export_country?.country_code,
    latitude: tradeDataDetail?.export_port?.latitude || tradeDataDetail?.export_country?.latitude,
    longitude: tradeDataDetail?.export_port?.longitude || tradeDataDetail?.export_country?.longitude,
    port_name: tradeDataDetail?.transaction?.export_port,
    address: tradeDataDetail?.export_port?.address,
  };

  return (
    <ExpandableBox title="Mapped Addresses" openDefault={true} flex={1}>
      <Box
        padding={3}
        display="flex"
        flexDirection="column"
        bgcolor={theme.palette.background.default}
        borderRadius={`0px 0px ${theme.shape.borderRadius * 2}px ${theme.shape.borderRadius * 2}px`}
      >
        <WorldMapChart
          data={[
            [(locationImport?.country_code || '')?.toLowerCase(), 10],
            [(locationExport?.country_code || '')?.toLowerCase(), 20],
          ]}
          tooltipFormatter={function () {
            const point: Point = this.point;
            return `<div>
            <b>${point.name}</b>
            ${get(point, 'lat') ? `<p>Latitude: ${get(point, 'lat')}</p>` : ''}
            ${get(point, 'lon') ? `<p>Longitude: ${get(point, 'lon')}</p>` : ''}
          </div>`;
          }}
          dataPoint={[
            {
              lon: locationImport?.longitude || 0,
              lat: locationImport?.latitude || 0,
              name: locationImport?.country_code || '',
              dataLabels: getDataLabelOptionBillOfLanding({
                code: locationImport?.country_code || '',
                companyName: locationImport?.port_name || '',
                address: locationImport?.address || '',
                companyType: 'Buyer',
              }),
            },
            {
              lon: locationExport?.longitude || 0,
              lat: locationExport?.latitude || 0,
              name: locationExport?.country_code || '',
              dataLabels: getDataLabelOptionBillOfLanding({
                code: locationExport?.country_code || '',
                companyName: locationExport?.port_name || '',
                address: locationExport?.address || '',
                companyType: 'Supplier',
              }),
            },
          ]}
          dataLine={[
            {
              geometry: {
                type: 'LineString',
                coordinates: [
                  [locationExport?.longitude || 0, locationExport?.latitude || 0],
                  [locationImport?.longitude || 0, locationImport?.latitude || 0],
                ],
              },
            },
          ]}
          height={600}
          type={WorldMapOptions.company_bill_of_landing}
        />
      </Box>
    </ExpandableBox>
  );
};

export default MapAddress;
